<template>
    <div>
      <RequestSummary/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import RequestSummary from '@/components/RequestSummary.vue'
  
  export default {
    name: 'request-summary',
    components: {
      RequestSummary
    }
  }
  </script>
  